import { render, staticRenderFns } from "./work-view.vue?vue&type=template&id=292492b9"
import script from "./work-view.vue?vue&type=script&lang=ts"
export * from "./work-view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports